import {useEffect} from 'react';
import queryString from 'query-string'
import utils from '../../libs/utils'

export default function PopupTransactionFinish() {
  useEffect(() => {
    const parsedQuery = queryString.parse(window.location.search);
    const correlationID = parsedQuery.cid;
    let validResultParams = ['error', 'walletId'];
    window?.opener?.postMessage({type: 'POPUP_FINISHED', correlationID: correlationID, result: utils.createResult(validResultParams, window.location.search)}, '*');
  }, []);
  return (
    ""
  );
}